import { render, staticRenderFns } from "./table32.vue?vue&type=template&id=d7ca7432&scoped=true&"
import script from "./table32.vue?vue&type=script&lang=js&"
export * from "./table32.vue?vue&type=script&lang=js&"
import style0 from "./table32.vue?vue&type=style&index=0&id=d7ca7432&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7ca7432",
  null
  
)

export default component.exports